module.exports = __webpack_public_path__ + "static/media/15.eb769010.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/15.jpg
// module id = 384
// module chunks = 0